import React, { FC } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../store';
import MissingArticle from '../components/MissingArticle';
import { setCurrentLightbox } from '../store/application/actions';
import { Platform, WriteDirection, RangeSettings, Lightbox } from 'sofa-reborn-react';
import { UrlService } from '../services';
import {
	setPersistedConfiguration,
	setGalleryPredefinedConfigurationId,
	setGalleryVpcCode,
	setMissingDeeplink,
} from '../store/sofaConfiguration/actions';
import { PromptButtonTypeEnum } from '@inter-ikea-kompis/component-prompt';
import { localeService } from '../services';

const MissingArticleContainer: FC = () => {
	const platform = useSelector<RootState, Platform>((state) => state.deviceInfo.platform);
	const writeDirection = useSelector<RootState, WriteDirection>(
		(state) => state.localization.writeDirection
	);
	const rangeSettings = useSelector<RootState, RangeSettings>(
		(state) => state.settings.rangeSettings as RangeSettings
	);

	const currentLightbox = useSelector<RootState, Lightbox>(
		(state) => state.application.currentLightbox
	);
	const missingDeeplink = useSelector<RootState, string | null>(
		(state) => state.sofaConfiguration.missingDeeplink
	);

	const dispatch = useDispatch<AppDispatch>();

	const resetMissingDeeplink = (): void => {
		if (missingDeeplink) {
			dispatch(setMissingDeeplink(null));
		}
	};

	const startFromScratch = (): void => {
		resetMissingDeeplink();
		dispatch(setCurrentLightbox('none'));
		dispatch(setGalleryPredefinedConfigurationId('blank'));
		dispatch(setPersistedConfiguration(null));
		const newHash = UrlService.getReplacedIdHash('blank');
		UrlService.setBrowserWindowHash(newHash);

		dispatch(setGalleryVpcCode());
	};

	const selectNewConfiguration = (): void => {
		resetMissingDeeplink();
		/* Remove vpc from url */
		const newHash = UrlService.getReplacedIdHash('blank');
		UrlService.setBrowserWindowHash(newHash);
		dispatch(setPersistedConfiguration(null));
		dispatch(setCurrentLightbox('product-intro-gallery'));
	};

	return (
		<MissingArticle
			platform={platform}
			writeDirection={writeDirection}
			showPrompt={currentLightbox === 'missing-article'}
			missingDeeplink={missingDeeplink}
			onClick={(event: CustomEvent) => {
				if (event.detail.type === PromptButtonTypeEnum.primaryButton) {
					startFromScratch();
				} else {
					selectNewConfiguration();
				}
			}}
			showUseFromScratchButton={
				missingDeeplink ? true : (rangeSettings.shouldColorAllModules as boolean)
			}
			missingArticleDescription={
				rangeSettings.shouldColorAllModules
					? localeService.getTranslation('invalidConfigurationDescription')
					: localeService.getTranslation('sprValidationUnavailableInfo')
			}
		></MissingArticle>
	);
};

export default MissingArticleContainer;
